export const OAUTH_SESSION_KEYS = {
  US_SESSION_INTERACTION: 'oauth.us.interaction.uid',
  ROW_SESSION_INTERACTION: 'oauth.row.interaction.uid',
  US_RETURN_URL: 'oauth.us.returnUrl',
  ROW_RETURN_URL: 'oauth.row.returnUrl',
  KYC_RETURN_URL: 'oauth.kyc.returnUrl',
  SWITCH_ENV_PATH: 'oauth.switchEnvPath',
};

export default OAUTH_SESSION_KEYS;
